import { render, staticRenderFns } from "./MobileRegionLabel.vue?vue&type=template&id=c7738468&scoped=true&"
import script from "./MobileRegionLabel.vue?vue&type=script&lang=js&"
export * from "./MobileRegionLabel.vue?vue&type=script&lang=js&"
import style0 from "./MobileRegionLabel.vue?vue&type=style&index=0&id=c7738468&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7738468",
  null
  
)

export default component.exports